var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag title",class:{ inactive: !_vm.portal.win.active }},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"minify",on:{"click":_vm.hide}}),_vm._v(" "),_c('div',{staticClass:"close",on:{"click":_vm.close}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79e5d5ad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Apps/TitleBar/index.vue
// module id = null
// module chunks = 